import { cva } from '@/styled-system/css';

export const switchHandleRecipe = cva({
  base: {
    'position': 'absolute',
    'transition': {
      _motionReduce: 'none',
      _motionSafe: '{transitions.Switch.Handle}',
    },
    '& [data-c11n-component="Icon"]': {
      position: 'absolute',
      top: '0',
      left: '0',
      height: '100%',
      width: '100%',
    },
  },
  variants: {
    checkedState: {
      true: {
        color: 'Switch.Handle.selected',
      },
      false: {
        color: 'Switch.Handle.default',
      },
    },
    size: {
      md: {
        left: 'Switch.Handle.md.position.left',
        top: 'Switch.Handle.md.position.top',
        borderRadius: 'Switch.Handle.md',
        height: 'Switch.Handle.md',
        width: 'Switch.Handle.md',
      },
      lg: {
        left: 'Switch.Handle.lg.position.left',
        top: 'Switch.Handle.lg.position.top',
        borderRadius: 'Switch.Handle.lg',
        height: 'Switch.Handle.lg',
        width: 'Switch.Handle.lg',
      },
    },
  },
  compoundVariants: [
    {
      size: 'md',
      checkedState: true,
      css: {
        transform: 'translateX({translate.Switch.Handle.md.x})',
      },
    },
    {
      size: 'lg',
      checkedState: true,
      css: {
        transform: 'translateX({translate.Switch.Handle.lg.x})',
      },
    },
  ],
});
